import type { SourceId } from '@/sources/types';

/**
 * Short uppercase tag shown on a `ComicCard` to indicate the source.
 * Falls back to the (lower-cased) id if the source is unknown.
 *
 * Why not just inline this in MatchGroup / Library? Multiple consumers
 * already exist (Library grid + MatchGroup row) and the tag set is short
 * enough to keep here without a per-source field on the registry.
 */
export function sourceBadge(sourceId: string): string {
  switch (sourceId as SourceId) {
    case 'ehentai':
      return 'eh';
    case 'exhentai':
      return 'ex';
    case 'hitomi':
      return 'ht';
    default:
      return sourceId.slice(0, 3).toUpperCase();
  }
}
